import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useNavigate } from 'react-router-dom'

const CancelSubmitModal = ({ isModalOpen, setModalOpen }) => {
  const navigate = useNavigate()

  const handleClose = () => {
    setModalOpen(false)
  }

  const handleConfirm = () => {
    navigate(-1)
  }

  return (
    <AdxInfoModal
      variant="error"
      open={isModalOpen}
      onClose={handleClose}
      muiIcon="warning"
      iconColor="error.main"
      title="Do you want to exit this evaluation?"
      subtitle="All answered questions will be discarded"
      footerButtons
      firstBtnLabel={'Confirm'}
      firstBtnHandle={handleConfirm}
      secondBtnLabel={'Close'}
      secondBtnHandle={handleClose}
    />
  )
}

export default CancelSubmitModal
